<template>
  
    <el-dialog
      title=""
      :visible.sync="$store.state.moduleObj.groupFalg"
      width="90%"
      :append-to-body="true"
      :close-on-click-modal="false"
      center>
        <div class="tabs-container ng-scope" v-if="$store.state.moduleObj.groupFalg" style="padding-bottom:50px;margin-top:18px;">
          <div id="wrapperp">
            <ul class="nav nav-tabs">
              <li
                class="tabLi"
                v-for="(data,$index) in $store.state.moduleObj.obj.langMap"
                :key="$index"
                :class="{'active':$index==0}"
              >
                <div class="tabDiv" @click="changeTabG($index)"></div>
                <a
                  :class="true?'tabG'+$index:''"
                  data-toggle="tab"
                  :href="true?'#tabG-'+$index:''"
                  aria-expanded="true"
                  @click="showTabG($event,$index)"
                >{{ $t("message." + data.langCode) }}</a>
              </li>
            </ul>
          </div>
          <el-form  :model="$store.state.moduleObj.obj" ref="groupDetail"  label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <div class="tab-content">
              <div
                :id="'tabG-'+index"
                v-for="(langData, index) in $store.state.moduleObj.obj.langMap"
                :key="index"
                class="tab-pane"
              >
                <div class="form-group"  v-if="$store.state.moduleObj.objType==1||$store.state.moduleObj.objType==2">
                    <label class="col-sm-2 control-label">Content</label>
                    <div class="col-sm-10">
                        <div>
                            <ckeditor :editor="editor"  @ready="onReady" v-model="langData.content" :config="editorConfig" ></ckeditor>
                        </div>
                        <el-form-item 
                            :prop="'langMap.' + index + '.content'"
                            :rules="{
                              required: true, message: $t('message.required'), trigger: 'blur'
                            }"
                          >
                            <el-input v-model="langData.content" style="display: none" show-word-limit ></el-input>
                        </el-form-item>
                    </div>
                </div> 
                <div class="form-group"  v-if="$store.state.moduleObj.objType==3">
                    <label class="col-sm-2 control-label">Content<span style="color:red">*</span></label>
                    <div class="col-sm-10">
                        <el-form-item 
                            :prop="'langMap.' + index + '.content'"
                            :rules="{
                              required: true, message: $t('message.required'), trigger: 'blur'
                            }"
                          >
                            <el-input v-model="langData.content" show-word-limit ></el-input>
                        </el-form-item>
                    </div>
                </div> 
                <div class="form-group"  v-if="$store.state.moduleObj.objType==4||$store.state.moduleObj.objType==13">
                    <label class="col-sm-2 control-label">Image<span style="color:red">*</span></label>
                    <div class="col-sm-8" >
                      <el-form-item 
                          :prop="'langMap.' + index + '.url'"
                          :rules="{
                            required: true, message: $t('message.required'), trigger: 'change'
                          }"
                        >
                        <el-input v-model="langData.url" :change="setImage($store.state.moduleObj.obj.langMap,langData.url,'url')"  style="display: none" show-word-limit :maxlength="100"></el-input>
                        <file-upload
                          :fileUploadUrl="fileUploadUrl"
                          :limit="5"
                          v-model="langData.url"
                        >
                          <template v-slot:sizeError>
                            <div style="color:red">Size error!</div>
                          </template>
                          <template v-slot:dimensionError>
                            <div style="color:red">Dimension Error!</div>
                          </template>
                          <template v-slot:sizeHint>
                            <div style="font-size:12px;" v-if="$store.state.moduleObj.objType==13">(Suggested Size: 279 X 372; ratio 3:4)</div>
                            <div style="font-size:12px;" v-if="$store.state.moduleObj.objType==4">(Suggested Size: 750 X 563; ratio 4:3)</div>
                            <div>Max 5 MB.</div>
                          </template>
                        </file-upload>
                      </el-form-item>
                    </div>
                </div> 
                <div class="form-group"  v-if="$store.state.moduleObj.objType==5">
                    <label class="col-sm-2 control-label">Video<span style="color:red">*</span></label>
                    <div class="col-sm-10">
                        <el-form-item 
                            :prop="'langMap.' + index + '.url'"
                            :rules="{
                              required: true, message: $t('message.required'), trigger: 'blur'
                            }"
                          >
                            <el-input v-model="langData.url" show-word-limit ></el-input>
                        </el-form-item>
                    </div>
                </div> 
                <div class="form-group"  v-if="$store.state.moduleObj.objType==4||$store.state.moduleObj.objType==13">
                    <label class="col-sm-2 control-label">Caption</label>
                    <div class="col-sm-10">
                        <div>
                            <el-input v-model="langData.caption" show-word-limit ></el-input>
                        </div>
                    </div>
                </div> 
                <div class="form-group"  v-if="$store.state.moduleObj.objType==4||$store.state.moduleObj.objType==13">
                    <label class="col-sm-2 control-label">AltText</label>
                    <div class="col-sm-10">
                        <el-form-item 
                            :prop="'langMap.' + index + '.altText'"
                            :rules="{
                              required: false, message: $t('message.required'), trigger: 'blur'
                            }"
                          >
                            <el-input v-model="langData.altText" show-word-limit ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group"  v-if="$store.state.moduleObj.objType==5">
                    <label class="col-sm-2 control-label">Description</label>
                    <div class="col-sm-10">
                        <div>
                            <el-input v-model="langData.description" show-word-limit ></el-input>
                        </div>
                    </div>
                </div> 
                <div class="form-group"  v-if="$store.state.moduleObj.objType==4||$store.state.moduleObj.objType==6||$store.state.moduleObj.objType==7">
                    <label class="col-sm-2 control-label">Description</label>
                    <div class="col-sm-10">
                        <div>
                            <el-input v-model="langData.description" show-word-limit ></el-input>
                        </div>
                    </div>
                </div> 
                <div class="form-group"  v-if="$store.state.moduleObj.objType==6||$store.state.moduleObj.objType==7">
                    <label class="col-sm-2 control-label"></label>
                    <div  class="col-sm-10">*Please add images on the next page after clicking Confirm.</div>
                </div> 
                <div class="form-group"  v-if="$store.state.moduleObj.objType==8">
                    <label class="col-sm-2 control-label">Quote<span style="color:red">*</span></label>
                    <div class="col-sm-10">
                        <el-form-item 
                            :prop="'langMap.' + index + '.quote'"
                            :rules="{
                              required: true, message: $t('message.required'), trigger: 'blur'
                            }"
                          >
                            <el-input v-model="langData.quote" show-word-limit ></el-input>
                        </el-form-item>
                    </div>
                </div> 
                <div class="form-group"  v-if="$store.state.moduleObj.objType==8">
                    <label class="col-sm-2 control-label">Author<span style="color:red">*</span></label>
                    <div class="col-sm-10">
                        <el-form-item 
                            :prop="'langMap.' + index + '.author'"
                            :rules="{
                              required: true, message: $t('message.required'), trigger: 'blur'
                            }"
                          >
                            <el-input v-model="langData.author" show-word-limit ></el-input>
                        </el-form-item>
                    </div>
                </div> 
              </div>
            </div>
          </el-form>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$store.state.moduleObj.groupFalg = false">Cancel</el-button>
        <el-button type="primary"  @click="checkEvent()">Confirm</el-button>
      </span>
    </el-dialog>
</template>
<script>
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import fileupload from "./fileupload";
const upload = require('../../upload')
import config from "../../config";
export default {
  name: "groupDlgController",
  mixins: [config.globalMixin],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'Heading', 'bold', 'italic','underline','Link', 'bulletedList', 'numberedList' ],
         // extraPlugins: [ upload.MyCustomUploadAdapterPlugin ]
          // The configuration of the editor.
      },
      venueObj:[],
      venueList:[],
      frequencyObj:[],
      weekObj:[],
      monthObj:[],
      yearObj:[]
    };
  },
  components: {
    ClassicEditor,
    "file-upload": fileupload
  },
  methods: {
    onReady( editor )  {
        // Insert the toolbar before the editable area.
        editor.ui.getEditableElement().parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            editor.ui.getEditableElement()
        );
    },
    setImage(obj,value,item){
      for(var i=0;i<obj.length;i++){
        if(!obj[i][item]&&value){
          obj[i][item] = value
        }
      }
    },
    cancel: function() {
      this.$store.commit("setgroup", { string: "", boolean: false });
    },
    changeTabG: function(id) {
      $(".tabG" + id)
        .parent()
        .find("a")
        .click();
    },
    showTabG: function($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          // $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          // $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
    checkEvent:function(){

        this.$refs["groupDetail"].validate((valid) => {
          if (valid) {
            this.addEvent();
          } else {
            this.$toastr.w(this.$i18n.t("message.fillRequired"));
            return false;
          }
        });
    },
    addEvent:function(){
      this.$store.state.moduleObj.groupFalg = false;
      this.$store.state.moduleObj.callback()
    },
    async venueListEvent() {
      let objdata = this.getAuthObj();
      objdata.sortField = 'id';
      objdata.sortType = 'ASC';
      objdata.startRow = 0;
      objdata.maxRows = 1000000;
      objdata.status = 1;
      objdata.apiUrl = '/getVenueList'
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(!data) return;
      this.venueList = data.data.resultList;
      this.venueObj = [];
      for(var i=0;i<this.venueList.length;i++){
        this.venueObj.push({
          value: this.venueList[i].id,
          label: this.getObject(this.venueList[i].langMap,this.langKey[0]).content
        })
      }
    },
  },
  computed:{
      _obj(){
        return this.$store.state.moduleObj.groupFalg
      }
  },
  watch: {
    _obj:function(){
      if(this.$store.state.moduleObj.groupFalg){
        this.venueListEvent()
      }
      setTimeout(function(){
        $(".tabG" + 1)
          .parent()
          .find("a")
          .click();

        $(".tabG" + 0)
          .parent()
          .find("a")
          .click();
      })
    }
  },
  mounted() {
      this.eventTypeObj= [{
        value: '1',
        label: "Performing Arts"
      }, {
        value: '2',
        label: "Exhibitions"
      }, {
        value: '3',
        label: "Talks / Forums"
      }, {
        value: '4',
        label: "Guided Tour"
      }, {
        value: '5',
        label: "Workshops"
      }, {
        value: '6',
        label: "Screening"
      }, {
        value: '7',
        label: "Festival"
      }]
      this.repeatObj=[{
        value: '1',
        label: 'Never'
      }, {
        value: '2',
        label: 'Every Day'
      }, {
        value: '3',
        label: 'Every Week'
      }, {
        value: '4',
        label: 'Every 2 Weeks'
      }, {
        value: '5',
        label: 'Every Month'
      }, {
        value: '6',
        label: 'Every Year'
      }, {
        value: '7',
        label: 'Custom'
      }]
      this.typeObj=[{
        label: 'Talk'
      }, {
        label: 'Forum'
      }]
      this.visualTypeObj=[{
        value: 'video',
        label: 'video'
      }, {
        value: 'image',
        label: 'image'
      }]
      this.frequencyObj = [{
        value: '1',
        label: 'Day'
      },{
        value: '2',
        label: 'Week'
      },{
        value: '3',
        label: 'Month'
      },{
        value: '4',
        label: 'Year'
      }]
      this.weekObj=[{
        value: '1',
        label: 'Monday'
      },{
        value: '2',
        label: 'Tuesday'
      },{
        value: '3',
        label: 'Wednesday'
      },{
        value: '4',
        label: 'Thursday'
      },{
        value: '5',
        label: 'Friday'
      },{
        value: '6',
        label: 'Saturday'
      },{
        value: '7',
        label: 'Sunday'
      }]
      this.monthObj=[{
        value: '1'
      },{
        value: '2'
      },{
        value: '3'
      },{
        value: '4'
      },{
        value: '5'
      },{
        value: '6'
      },{
        value: '7'
      },{
        value: '8'
      },{
        value: '9'
      },{
        value: '10'
      },{
        value: '11'
      },{
        value: '12'
      },{
        value: '13'
      },{
        value: '14'
      },{
        value: '15'
      },{
        value: '16'
      },{
        value: '17'
      },{
        value: '18'
      },{
        value: '19'
      },{
        value: '20'
      },{
        value: '21'
      },{
        value: '22'
      },{
        value: '23'
      },{
        value: '24'
      },{
        value: '25'
      },{
        value: '26'
      },{
        value: '27'
      },{
        value: '28'
      },{
        value: '29'
      },{
        value: '30'
      },{
        value: '31'
      }]
      this.yearObj = [{
        value: '1'
      },{
        value: '2'
      },{
        value: '3'
      },{
        value: '4'
      },{
        value: '5'
      },{
        value: '6'
      },{
        value: '7'
      },{
        value: '8'
      },{
        value: '9'
      },{
        value: '10'
      },{
        value: '11'
      },{
        value: '12'
      }]
  },
};
</script>
